import { useLocation } from 'react-router-dom';

import { SidebarHelper } from '@widgets/sidebar/lib/helpers';

export const useActiveSection = (path: string) => {
  const location = useLocation();

  const sectionPathname = SidebarHelper.extractSectionNameFromPath(path);
  const locationPathname = SidebarHelper.extractSectionNameFromPath(location.pathname);

  const isActive = locationPathname === sectionPathname;

  return isActive;
};
